module.exports = __webpack_public_path__ + "static/img/icon_footer_half_round.3f25f5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_footer_half_round.png
// module id = JMBg
// module chunks = 34